import React from 'react';
import { Typography, Space } from 'antd';
import { Check, X } from 'lucide-react';

const { Text } = Typography;

interface Requirement {
  label: string;
  met: boolean;
}

interface Props {
  password: string;
}

export const PasswordRequirements: React.FC<Props> = ({ password }) => {
  const requirements: Requirement[] = [
    {
      label: 'At least 8 characters',
      met: password.length >= 8,
    },
    {
      label: 'Contains uppercase letter',
      met: /[A-Z]/.test(password),
    },
    {
      label: 'Contains lowercase letter',
      met: /[a-z]/.test(password),
    },
    {
      label: 'Contains number',
      met: /\d/.test(password),
    },
  ];

  return (
    <div className="mt-[-10px] mb-8">
      <Text type="secondary" className="text-sm mb-2 block">
        Password requirements:
      </Text>
      <Space direction="vertical" size="small">
        {requirements.map((req, index) => (
          <div key={index} className="flex items-center gap-2">
            {req.met ? (
              <Check className="h-4 w-4 text-green-500" />
            ) : (
              <X className="h-4 w-4 text-gray-300" />
            )}
            <Text
              className={req.met ? 'text-green-700' : 'text-gray-500'}
              style={{ fontSize: '13px' }}
            >
              {req.label}
            </Text>
          </div>
        ))}
      </Space>
    </div>
  );
};